// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sugId: __t.u64().primaryKey().name("sug_id"),
  identity: __t.identity(),
  eventId: __t.u64().name("event_id"),
  curator: __t.identity(),
  welcomingScore: __t.f32().name("welcoming_score"),
  at: __t.timestamp(),
});
